<script setup>
import {reactive, ref} from "vue";
import {validateNumber} from "../../store/form_validate"
import {useSystem} from "../../store/system"
import {useUser} from "../../store/user"
import {ElMessage} from "element-plus";
import VueQrcode from 'vue-qrcode';
import {base_url} from  '../../api/baseUrl'

const userStore = useUser()
const systemStore = useSystem()
//获取支付方式
systemStore.getPaymentListApi()
//获取所有充值记录 recent | all
userStore.depositLogApi('all')

const ruleFormRef = ref(null)
const ruleFormRef1 = ref(null)
const ruleForm = reactive({
  origin_amount: '',
  amount: 0,
  payment_id: '',
  note: '',
  txid: '',
})

const rules = reactive({
  origin_amount: [
    {required: true, validator: validateNumber, message: 'Invalid number!', trigger: 'blur'},
  ],
  payment_id: [
    {required: true, message: 'Please choose payment!', trigger: 'blur'},
  ],
  txid: [
    {required: false, message: 'Please enter txid!', trigger: 'blur'},
  ],
})

const submitLoading = ref(false)
const submitForm = async (formEl) => {
  if (!formEl) return
  submitLoading.value = true
  await formEl.validate(async (valid, fields) => {
    if (valid) {
      if (parseFloat(ruleForm.origin_amount) < parseFloat(currentPayment.value.min) ||
        parseFloat(ruleForm.origin_amount) > parseFloat(currentPayment.value.max)) {
        ElMessage({
          duration: 1500,
          message: `Amount min ${parseFloat(currentPayment.value.min)} max ${currentPayment.value.max}`,
          type: 'error',
          onClose: () => {
            submitLoading.value = false
          }
        })
        return
      }
      systemStore.currencyConversionApi(ruleForm.origin_amount, currentPayment.value.coin_symbol, async (converAmount) => {
        ruleForm.amount = converAmount
        dialogVisible.value = true

        await userStore.userRechargeApi(ruleForm)
      })

      setTimeout(() => {
        userStore.depositLogApi('all')
      }, 1000)
    } else {
      console.log('error submit!', fields)
    }
    submitLoading.value = false
  })
}
const resetForm = (formEl) => {
  if (!formEl) return
  formEl.resetFields()
}

const dialogVisible = ref(false)
const currentPayment = ref(null)
const paymentChange = (value) => {
  let payment = systemStore.getPaymentList.find(item => item.id == value)
  currentPayment.value = payment
}

const isEdit = ref(false)
const uploadImageUrl = ref('')
const handleUploadSuccess = (response, uploadFile, uploadFiles) => {
  // console.log(11111, response)
  // console.log(123123, uploadFile)
  // console.log(22222, uploadFiles)
  uploadImageUrl.value = URL.createObjectURL(uploadFile.raw)
  ruleForm.note = response.data.url
}
const rechargeSubmit = async (formEl) => {
  if (!formEl) return
  submitLoading.value = true
  await formEl.validate(async (valid, fields) => {
    if (valid) {
      await userStore.userRechargeUploadApi({
        id: userStore.getRechargeId,
        txid: ruleForm.txid,
        note: ruleForm.note
      })
      dialogVisible.value = false
      // resetRuleForm()
      setTimeout(() => {
        userStore.depositLogApi('all')
      }, 1000)
    }
  })
  ruleFormRef.value.resetFields()
  formEl.resetFields()
  submitLoading.value = false
  dialogVisible.value = false
  uploadImageUrl.value = ''
}

const uploadProof = async (id) => {
  userStore.rechargeId = id
  await userStore.userRechargeDetailApi({id})
  paymentChange(userStore.getRechargeDetail.payment_id)
  isEdit.value = false
  dialogVisible.value = true
}
const viewDetail = async (id) => {
  isEdit.value = true
  userStore.rechargeId = id
  await userStore.userRechargeDetailApi({id})
  paymentChange(userStore.getRechargeDetail.payment_id)
  dialogVisible.value = true
}

const dialogClose = () => {
  isEdit.value = false
  userStore.clearRechargeDetail()
  ruleForm.amount = 0
}

const copyText = (value) => {
  systemStore.copyTxt('.copyBtn', value, 'copy success!', 'copy error!')
}


</script>

<template>
  <el-row>
    <el-col :span="24">
      <div class="card-bg">
        <div class="tw-p-4 tw-bottom-line tw-font-bold tw-text-[18px]">Deposit</div>
        <div class="tw-p-4 tw-flex tw-justify-center">
          <el-form
              ref="ruleFormRef"
              :model="ruleForm"
              :rules="rules"
              label-width="auto"
              label-position="top"
              class="tw-w-full"
              size="large"
              status-icon
          >
            <el-form-item label="Deposit Network" prop="payment_id">
              <el-select v-model="ruleForm.payment_id" placeholder="Deposit Network" @change="paymentChange">
                <el-option
                    class="!tw-h-[45px]"
                    v-for="(item, index) in systemStore.getPaymentList"
                    :label="item.name"
                    :key="index"
                    :value="item.id"
                >
                  <div class="tw-h-full tw-flex tw-justify-start tw-items-center">
                    <el-avatar :size="30" :src="item.image" />
                    <div class="tw-ml-2">{{item.name}}</div>
                  </div>
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="Amount" prop="origin_amount">
              <el-input type="number" :min="currentPayment? currentPayment.min: 0" :max="currentPayment? currentPayment.max: 0" v-model="ruleForm.origin_amount" placeholder="Please enter USD">
                <template #prefix>
                  <i class="ti ti-currency-dollar tw-text-gray-500 tw-text-[18px]"></i>
                </template>
              </el-input>
            </el-form-item>

            <el-form-item>
              <div class="tw-mt-[1rem] tw-flex tw-justify-end tw-w-full tw-space-x-5">
                <el-button @click="resetForm(ruleFormRef)">Clear</el-button>
                <el-button :loading="submitLoading" type="primary" @click="submitForm(ruleFormRef)">
                  Submit
                </el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-col>

    <!-- Deposit Log -->
    <el-col :span="24">
      <div class="card-bg tw-mt-8">
        <div class="tw-p-4 tw-bottom-line tw-font-bold tw-text-[18px]">Deposit Log</div>
        <div class="tw-p-4">
          <el-table
              :data="userStore.getDepositLog"
              class="tw-w-full"
          >
            <el-table-column prop="createtime" label="Date">
              <template #default="{row, column, $index}">
                <div>{{systemStore.formatDate(row.createtime)}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="order_number" label="Order No">
              <template #default="{row, column, $index}">
                <div>{{row.order_number}}</div>
              </template>
            </el-table-column>
<!--            <el-table-column prop="submit_amount" label="Recharge amount">-->
<!--              <template #default="{row, column, $index}">-->
<!--                <div>$ {{parseFloat(row.submit_amount).toFixed(2)}}</div>-->
<!--              </template>-->
<!--            </el-table-column>-->
            <el-table-column prop="amount" label="Amount">
              <template #default="{row, column, $index}">
                <div>$ {{parseFloat(row.amount).toFixed(2)}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="payment_id" label="Payment">
              <template #default="{row, column, $index}">
                <div class="tw-h-full tw-flex tw-justify-start tw-items-center">
                  <el-avatar class="tw-flex-none" v-if="row.image" :size="30" :src="row.image" />
                  <div class="tw-ml-2">{{row.name}}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="Status">
              <template #default="{row, column, $index}">
<!--                0待审核 1通过 2拒绝-->
                <div class="tw-inline-block tw-py-1 tw-px-2 tw-bg-blue-500 tw-rounded-md tw-text-center tw-bg-opacity-60 !tw-text-[13px]" v-if="row.status == 0">Pending payment</div>
                <div class="tw-inline-block tw-py-1 tw-px-2 tw-bg-green-500 tw-rounded-md tw-text-center tw-bg-opacity-60 !tw-text-[13px]" v-if="row.status == 1">Passed</div>
                <div class="tw-inline-block tw-py-1 tw-px-2 tw-bg-red-500 tw-rounded-md tw-text-center tw-bg-opacity-60 !tw-text-[13px]" v-if="row.status == 2">Reject</div>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="Remark"></el-table-column>
            <el-table-column prop="note" label="Action">
              <template #default="{row, column, $index}">
                <el-button @click="uploadProof(row.id)" class="!tw-text-[14px]" v-if="!row.note || row.note.length == 0"><el-icon size="16" class="tw-mr-1"><Paperclip /></el-icon>Upload Proof</el-button>
                <el-button @click="viewDetail(row.id)" type="primary" class="!tw-text-[14px]" v-else><el-icon size="16" class="tw-mr-1"><View /></el-icon>View</el-button>
              </template>
            </el-table-column>
            <template #empty>
              <el-empty :image-size="120"></el-empty>
            </template>
          </el-table>
        </div>
      </div>
    </el-col>
    <el-col :span="24" class="mt-4">
      <el-pagination
          background layout="prev, pager, next"
          :page-size="parseInt(userStore.getDepositPage.limit)"
          :total="parseInt(userStore.getDepositPage.total)"
          @change="userStore.depositChange" />
    </el-col>
  </el-row>

  <!--    dialog modal-->
  <el-dialog class="dialog-bg dialog-bg xs:!tw-w-[90vw] md:!tw-w-[600px] !tw-mt-[5vh]" v-model="dialogVisible" :show-close="false" title="Shipping address" @close="dialogClose">
    <template #header="{ close, titleId, titleClass }">
      <div class="my-header">
        <h4 :id="titleId" :class="titleClass" class="xs:tw-ml-[2rem] md:tw-ml-[6rem] !tw-text-[24px] !tw-text-white tw-font-bold">Checkout</h4>
        <button class="modal__close" type="button" @click="dialogVisible = false"><i class="ti ti-square-x"></i></button>
      </div>
    </template>

    <div class="tw-py-2 xs:tw-px-[3rem] md:tw-px-[6rem] tw-pb-5 tw-text-white !tw-text-[16px]">
      <div class="tw-flex tw-justify-center tw-items-center">
        <vue-qrcode
            class="tw-rounded-lg"
            :color="{ dark: '#000000ff', light: '#ffffffff' }"
            type="image/jpeg"
            v-if="currentPayment.address"
            :value="currentPayment.address"
            :scale="8"
            :margin="1"
        ></vue-qrcode>
      </div>
      <div class="tw-text-[14px] !tw-text-orange-400 tw-mt-2">
        <div>Please send funds to the specified address or use a QR code for a deposit. Your amount will be deposited in your account.</div>
      </div>
      <div class="py-2 tw-mt-2">
        <div>Deposit Network</div>
        <div class="tw-flex tw-justify-between tw-items-center tw-mt-2">
          <el-select v-model="ruleForm.payment_id" :disabled="true" placeholder="Deposit Network" @change="paymentChange">
            <el-option
                class="!tw-h-[50px]"
                v-for="(item, index) in systemStore.getPaymentList"
                :label="item.name"
                :key="index"
                :value="item.id"
            >
              <div class="tw-h-full tw-flex tw-justify-start tw-items-center">
                <el-avatar :size="30" :src="item.image" />
                <div class="tw-ml-2">{{item.name}}</div>
              </div>
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="py-2" v-if="userStore.getRechargeDetail.id">
        <div>Deposit Amount</div>
        <div class="tw-flex tw-justify-between tw-items-center tw-mt-2">
          <el-input type="number" class="tw-h-[40px] tw-text-[18px] tw-font-bold" :model-value="parseFloat(userStore.getRechargeDetail.submit_amount).toFixed(8)" :readonly="true"></el-input>
          <el-button class="tw-h-[40px] tw-ml-2 copyBtn" type="primary" native-type="button" @click="copyText(parseFloat(userStore.getRechargeDetail.submit_amount).toFixed(8))"><el-icon size="18"><CopyDocument /></el-icon></el-button>
        </div>
      </div>
      <div class="py-2" v-else>
        <div>Deposit Amount</div>
        <div class="tw-flex tw-justify-between tw-items-center tw-mt-2">
          <el-input type="number" class="tw-h-[40px] tw-text-[18px] tw-font-bold" :model-value="parseFloat(ruleForm.amount).toFixed(8)" :readonly="true"></el-input>
          <el-button class="tw-h-[40px] tw-ml-2 copyBtn" type="primary" native-type="button" @click="copyText(parseFloat(ruleForm.amount).toFixed(8))"><el-icon size="18"><CopyDocument /></el-icon></el-button>
        </div>

      </div>
      <div class="py-2">
        <div>Wallet Address</div>
        <div class="tw-flex tw-justify-between tw-items-center tw-mt-2">
          <el-input type="text" v-if="currentPayment.address" class="tw-h-[40px] tw-text-[18px] tw-font-bold" :model-value="currentPayment.address" :readonly="true"></el-input>
          <el-button class="tw-h-[40px] tw-ml-2 copyBtn" type="primary" native-type="button" @click="copyText(currentPayment.address)"><el-icon size="18"><CopyDocument /></el-icon></el-button>
        </div>
      </div>
      <el-form
          ref="ruleFormRef1"
          :model="ruleForm"
          :rules="rules"
          label-width="auto"
          label-position="top"
          class="tw-w-full"
          size="large"
          status-icon
      >
        <div class="py-2">
          <el-form-item class="!tw-mb-0" label="TXID" prop="txid">
            <el-input class="tw-h-[40px] tw-text-[18px] tw-mt-2 tw-font-bold" type="text" v-model="ruleForm.txid" placeholder="Please enter txid" :readonly="isEdit"></el-input>
          </el-form-item>
        </div>
        <div class="py-2">
          <div>Payment Voucher</div>
          <el-upload
              v-if="!isEdit"
              class="el-custom-uploader tw-mt-2"
              :action="base_url+'/common/upload'"
              :headers="{token: userStore.getToken}"
              :data="{category: ''}"
              :show-file-list="false"
              :on-success="handleUploadSuccess"
          >
            <el-image v-if="uploadImageUrl" :src="uploadImageUrl" class="tw-h-[100px]" fit="cover"></el-image>
            <el-icon :size="50" v-else class="avatar-uploader-icon"><UploadFilled /></el-icon>
          </el-upload>
          <el-image v-if="isEdit" :src="userStore.getRechargeDetail.note" class="tw-w-full tw-mt-2 tw-rounded-md" fit="cover"></el-image>
        </div>
        <el-button v-if="!isEdit" :loading="submitLoading" class="section__btn tw-justify-self-left tw-w-full tw-mt-4" native-type="button" @click="rechargeSubmit(ruleFormRef1)"> {{submitLoading? 'Submitting ...': 'Submit'}}</el-button>
      </el-form>

      <div class="tw-text-[14px] !tw-text-orange-400 tw-mt-8">
        <div class="tw-mt-2">After confirming the transfer, please upload a screenshot with the TXID.Your deposit will be processed within 30 minutes. If you have any questions, please contact our 24-hour online support team.</div>
      </div>
    </div>

    <!-- design elements -->
    <span class="screw screw--big-tl"></span>
    <span class="screw screw--big-bl"></span>
    <span class="screw screw--big-br"></span>

  </el-dialog>
</template>

<style lang="scss">
.el-select__wrapper{
  height: 40px;
}
.el-custom-uploader{
  background: #FFFFFF;
  text-align: center;
  //align-content: center;
  border-radius: 8px;
  color: #5c636a;

  .el-upload{
    padding: 20px;
  }
}
.el-form-item__label{
  color: $p-text-color !important;
}

.el-table {
  background-color: unset !important;
  color: #FFFFFF;
  border-color: $p-border-color !important;

  // 每行tr的底部线条
  td.el-table__cell, .is-leaf{
    border-bottom: 2px solid $p-border-color !important;
  }

  //解决最后一排边框线
  .el-table__inner-wrapper:before{
    background-color: unset !important;
  }

  .el-table__header-wrapper {
    tr {
      // 表头背景色
      background-color: unset;

      th {
        color: $p-text-color;
        background-color: rgba(0, 0, 0, 0);
      }
    }

  }

  .el-table__body-wrapper {
    tr {
      // 表格内容背景色
      background-color: unset;
      color: $p-text-color;

      &:hover>td {
        //修改(hover)悬浮背景色
        background-color: $p-table-row-active-color !important;
      }
    }
  }
}
</style>
